import request from '@/utils/request'

export function getNationalityList(params) {
  return request({
    url: '/api/v1/teachers/nationalityList',
    method: 'get',
    params
  })
}
export function getSocialList(params) {
  return request({
    url: '/api/v1/teachers/socialList',
    method: 'get',
    params
  })
}
export function getZoneList(params) {
  return request({
    url: '/api/v1/teachers/zoneList',
    method: 'get',
    params
  })
}
export function updateUserInfo(data) {
  return request({
    url: '/api/v1/teachers/update',
    method: 'post',
    data
  })
}
export function updatePassword(data) {
  return request({
    url: '/api/v1/teachers/updatePassword',
    method: 'post',
    data
  })
}
export function updateUserVideo(data) {
  return request({
    url: '/api/v1/upload/introduction',
    method: 'post',
    data
  })
}
export function updateUserCertificate(data) {
  return request({
    url: '/api/v1/upload/certificate',
    method: 'post',
    data
  })
}
export function updateUserPassport(data) {
  return request({
    url: '/api/v1/upload/passport',
    method: 'post',
    data
  })
}
export function checkUserInfo(data) {
  if (data.phoneCode) {
    let phoneCode = data.phoneCode;
    let phone = data.phone;
    data.phone = `+${phoneCode}${phone}`;
  }
  data.startDate = data.workTime[0];
  data.endDate = data.workTime[1];
  return request({
    url: '/api/v1/teachers/basicinfo',
    method: 'post',
    data
  })
}
export function sendActivateEmial(params) {
  return request({
    url: '/api/v1/teachers/sendActivateEmial',
    method: 'get',
    params
  })
}

export function getSubjectList(params) {
  return request({
    url: '/api/v2/comm/vt/getSubjectList',
    method: 'get',
    params
  })
}


// WEBPACK FOOTER //
// ./src/api/me.js